export default __webpack_public_path__ + "static/media/promos-icon-active.610255e4.webp";